<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div
              class="flash-message col-md-4 col-md-offset-4 text-center"
              v-if="flash"
            >
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details" class="row">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.cityId)"
                  >
                    <label>City</label>
                    <select
                      required
                      name="cityId"
                      class="form-control"
                      :disabled="isCityDisable"
                      v-model="vendor.cityId"
                    >
                      <option value="" disabled>Select City Name</option>
                      <option v-for="cityId in citys" :value="cityId.id"
                        >{{ cityId.name }}
                      </option>
                    </select>
                    <field-messages
                      name="cityId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">This is required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.vdName)"
                  >
                    <label>Vendor Name</label>
                    <input
                      maxlength="25"
                      type="text"
                      name="vdName"
                      class="form-control"
                      required
                      v-model="vendor.vdName"
                      placeholder="Vendor Name"
                      pattern="^[a-zA-Z\sand mod]{0,25}"
                    />
                    <field-messages
                      name="vdName"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Vendor Name is a required field</div>
                      <div slot="pattern">
                        Alphabets are allowed.
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.vdContact)"
                  >
                    <label>Contact Number</label>
                    <input
                      type="text"
                      maxlength="10"
                      name="vdContact"
                      class="form-control"
                      required
                      v-model="vendor.vdContact"
                      placeholder="Contact Number"
                      pattern="[78965][0-9]{9}"
                    />
                    <field-messages
                      name="vdContact"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Contact Number is a required field
                      </div>
                      <div slot="pattern">Numbers are allowed.</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group"
                    :class="fieldClassName(formstate.vdEmail)"
                    :custom="{ email: emailValidator }"
                  >
                    <label>Email</label>
                    <input
                      type="text"
                      name="vdEmail"
                      class="form-control"
                      v-model="vendor.vdEmail"
                      placeholder="Email"
                    />
                    <field-messages
                      name="vdEmail"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="email">Email Id is invalid</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>
            <!-- v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]" -->
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'vendor' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="createVendor"
                :disabled="!(formstate.$dirty && formstate.$valid)"
                v-if="$route.params && $route.params._id == '0'"
              >
                Add Vendor
              </button>
              <button
                class="btn gradientbt mr-5"
                type="submit"
                @click="updateVendor"
                :disabled="!(formstate.$dirty && formstate.$valid)"
                v-if="$route.params && $route.params._id != '0'"
              >
                Update Vendor
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../../../store";
import { formService, eventBus, vendorService } from "../../../services";
import { EVENTS } from "../../../config";
import { USER_ROLES } from "../../../config";
import { mapState } from "vuex";
import { log } from "console";

export default {
  name: "vendorCreate",
  data() {
    return {
      isCityDisable: false,
      ready: false,
      USER_ROLES: USER_ROLES,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: "",
      EVENTS: EVENTS,
      formstate: {},
      vendor: {
        cityId: "",
      },
      oldVendor: {},
      vendorId: [],
      citys: {},
      // vendorId: this.$route.params._id,
    };
  },
  mounted() {
    this.getCityList();
  },

  methods: {
    fieldClassName: formService.fieldClassName,
    emailValidator: formService.emailValidator,

    getCityList() {
      if (this.$store.state.auth.user.role.key === "cityAdmin") {
        const { _id, cityName } = this.$store.state.auth.user.cityId;
        this.citys = [{ id: _id, name: cityName }];
        this.vendor["cityId"] = _id;
        this.isCityDisable = true;
        return;
      }
      this.loading = true;
      const params = {};
      let cityList = [];
      // params.page = 1;
      // params.limit = 999;
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            if (element.status === true) {
              cityList.push({
                name: element.cityName,
                id: element._id,
              });
            }
          });
          cityList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.citys = cityList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("citys.requestFunction-error:", error);
          this.$snotify.error("Get citys list failed", "Error!");
        });
    },

    getVendor() {
      const params = {};
      let vendorData = [];
      return vendorService
        .getById(this.$route.params._id)
        .then((response) => {
          vendorData = response.data.response;
          vendorData["cityName"] = response.data.response.cityId.cityName;
          vendorData["cityId"] = response.data.response.cityId._id;
          this.vendor = vendorData;
          this.oldVendor = _.cloneDeep(this.vendor);
          this.$store.dispatch("setBreadcrumbTitle", this.vendor.vdName);
        })
        .catch((error) => {
          console.error("Vendor.Vendor-error:", error);
          this.$snotify.error("Get Vendor failed", "Error!");
        });
    },

    createVendor() {
      this.loading = true;
      let data = {};
      data["cityId"] = this.vendor["cityId"];
      data["vdName"] = this.vendor["vdName"];
      data["vdContact"] = this.vendor["vdContact"];
      if (
        !this.vendor.vdEmail ||
        this.vendor.vdEmail == "" ||
        this.vendor.vdEmail == null
      ) {
        delete this.vendor.vdEmail;
      } else {
        data["vdEmail"] = this.vendor["vdEmail"];
      }

      return vendorService
        .addVendor(data)
        .then((response) => {
          this.loading = false;
          this.flash = false;

          this.$snotify.success(
            `The ${this.vendor.vdName} has been added successfully.`,
            "Success!"
          );
          this.$router.push("/vendor");
        })
        .catch((error) => {
          this.loading = false;
          if (error.data.message == "Mobile Number already in use.") {
            var errorMessage = "Mobile Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Email already in use.") {
            var errorMessage = "Email Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else {
            this.$snotify.error("Vendor Create Failed.", "Error!");
          }
        });
    },

    clearChanges() {
      this.vendor = _.cloneDeep(this.oldVendor);
      this.formstate._reset();
    },
    updateVendor() {
      const id = this.$route.params._id;
      this.loading = true;
      this.data = {};
      this.data["cityId"] = this.vendor["cityId"];
      this.data["_id"] = this.vendor["_id"];
      this.data["vdName"] = this.vendor["vdName"];

      if (
        !this.vendor.vdEmail ||
        this.vendor.vdEmail == "" ||
        this.vendor.vdEmail == null
      ) {
        delete this.vendor.vdEmail;
      } else {
        this.data["vdEmail"] = this.vendor["vdEmail"];
      }

      this.data["vdContact"] = this.vendor["vdContact"];
      return vendorService
        .updateVendor(id, this.data)
        .then((response) => {
          this.loading = false;
          this.flash = false;
          this.formstate._reset();
          this.oldVendor = _.cloneDeep(this.vendor);
          this.$snotify.success(
            `The ${this.vendor.vdName} has been updated successfully.`
          );
          this.$router.push("/vendor");
        })
        .catch((error) => {
          this.loading = false;
          if (error.data.message == "Mobile Number already in use.") {
            var errorMessage = "Mobile Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Email already in use.") {
            var errorMessage = "Email Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else {
            this.$snotify.error("Vendor Update Failed.", "Error!");
          }
        });
    },
  },
  created() {
    const promises = [];
    this.loading = true;
    // promises.push(this.getVendor());
    if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
      promises.push(this.getVendor());
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  beforeDestroy() {},

  fieldClassName: function(field) {
    if (!field) {
      return "";
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return "has-success";
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return "has-danger";
    }
  },

  // computed: {
  //     ...mapState({
  //         user: state => state.auth.user,
  //     })
  // }
};
</script>

<style scoped>
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.mt {
  margin-top: 7px;
}

.gradientbt {
  background: #3085d6;
  color: white;
}
</style>



// WEBPACK FOOTER //
// vendorCreate.vue?3f93ad54